import axios from "axios"
import store from "@/store"

export default () => {
  const api = axios.create({
    baseURL: __.platform.baseUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Platform-Language": store.getters.language.code,
      "Channel-Language": sessionStorage.getItem("channel-language") || store.getters.language.code,
      "Device-Type": __.device.properties.type
    }
  })

  api.interceptors.response.use(
    response => response.data,
    err => {
      if (store.state.splash && (!err.response || err.response.data === "connect ETIMEDOUT"))
        store.commit("error", err.response ? err.response.data : err.message || err)

      if (!store.state.router && [500, 502, 503, 504].includes(err.response?.status || err.status)) {
        const randomValue_ = Math.floor(Math.random() * (120 - 30 + 1) + 30)
        store.commit("error", `Something went wrong, the platform will reload itself, please wait  ${randomValue_} second.`)
        setTimeout(() => window.location.reload(true), randomValue_ * 1000)
      }

      if (!err.response || err.response.status === 404) return false
      if (!store.state.router && [402, 401, 406, 426].includes(err.response?.status || err.status))
        store.commit("error", err.response ? err.response.data : err)
      return _$.error(err.response ? err.response.data : err)
    }
  )

  return api
}
